import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";

const MSALLogin = () => {

	const { instance, accounts } = useMsal();

	const isAuthenticated = useIsAuthenticated();
	const navigate = useNavigate();

	const [error, setError] = useState<string>("");
	const [inProgress, setInProgress] = useState<boolean>(false);

	/**
	 * Method that handles click on login button 
	 * for showing MS login form.
	 */
	async function handleLogin() {

		/* Interactive login for authenticating user against Azure AD B2C */
		instance.loginPopup({ scopes: ["api://UnitCostsAPI/access_as_user"] })
			.then(response => {
				instance.setActiveAccount(response.account);
				/* Navigate to overview page */
				navigate("/admin/claims");
			})
			.catch(error => { setError(error) });
	}

	useEffect(() => {
		/* Check if user is already authenticated by MSAL */
		if (isAuthenticated) {
			/* User is already authenticated */
			navigate("/admin/claims");
		}

		if (accounts.length === 1) {

			setInProgress(true);

			/* Try to login user silently */
			instance.acquireTokenSilent({ scopes: ["api://UnitCostsAPI/access_as_user"] })
				.then(silentResponse => {
					/* SSO Login successfully */
					instance.setActiveAccount(silentResponse.account);
					navigate("/admin/claims");
				})
				.catch(error => {
					/* Check if error indicates that interaction is required */
					if (!(error instanceof InteractionRequiredAuthError)) {

						// TO-DO: Add proper error handling for catched error message ...
					}
				})
				.finally(() => setInProgress(false));
		}
	}, [isAuthenticated, accounts.length, navigate, instance])

	/* JSX Element that represent the current login page */
	return (
		<main className="container mb-5">

			<div className="row text-center">
				<div className="col-12">
					<img src="/brand.png" alt="brand" className="brand" />
				</div>
			</div>

			<div className="row text-center">
				<div className="col-12 col-md-7 mx-auto">
					<h4>Unit Costs Management console</h4>
					<p>Please click the button below to login with your Microsoft 365 account.</p>
				</div>
			</div>

			{(error) && (
				<div className="row">
					<div className="col-12 col-md-7 mx-auto">
						<div className="alert alert-danger fw-bold">
							{error}
						</div>
					</div>
				</div>
			)}

			<div className="row">
				<div className="col-12 col-md-7 mx-auto">

					<div className="card">
						<div className="card-body">
							<div className="row">
								<div className="form-group col-12 mt-2">
									{ /* Login Button for init MSOL request */}
									{inProgress
										? <button type="button" disabled className="btn btn-outline-warning w-100"><img src="/loading.gif" alt="spinning_loader" className="spinning-loader"></img></button> 
										: <button type="button" className="btn btn-warning w-100 fw-bold" onClick={handleLogin}><i className="bi bi-microsoft me-2"></i>Login with Microsoft</button>
									}
								</div>
							</div>
						</div>
					</div>

				</div>
			</div>

		</main>
	)
	
}
export default MSALLogin;